exports.default = {
  'recent_use': '最近使用',
  'search': '搜索智能体',
  'search_not_found': '没有找到与{ value }相关的搜索结果',
  'more_result': '更多关于{ value }搜索的结果 >'
}
